import { useFormContext } from "react-hook-form";
import { BondSummary as RequestBondSummary } from "../../../../../agent/request/create/steps/bond/BondSummary";
import { matchingPrincipalName } from "../../../../../shared/bond/principal";
import { type AdminCombinedFormData, withResolvedPrincipal } from "../../schema";

export const BondSummary = () => {
	const { getValues } = useFormContext<AdminCombinedFormData>();
	const { account, quote } = withResolvedPrincipal(getValues());

	return (
		<RequestBondSummary
			includeCommercialFields
			principalName={
				matchingPrincipalName({
					companies: account?.details?.companies,
					principalName: quote?.principal?.name,
				}) ?? null
			}
		/>
	);
};
